import { render, staticRenderFns } from "./ProjectSummaryPlaceholder.vue?vue&type=template&id=65d3b317&"
import script from "./ProjectSummaryPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ProjectSummaryPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports